//import "/src/stylus/style.styl";
//import { initializeObserver } from "./lib/inviewObserver";
import "./lib/menu";
import "./lib/common";
import "./lib/top/kv";
//import "./lib/top/scroll";
import "./lib/top/carousel";
import "./lib/top/department";
import "./lib/top/course";
import "./lib/top/topScroll";
import "./lib/admission/index";
import "./lib/article/index";
import "./lib/login";
class App {
    constructor() {
        //initializeObserver();
    }
}
new App();
